import React from "react";

function ClubInfo() {
  return (
    <div className="container">
      <h2 className="section-title">What We Offer</h2>
      <div className="card-grid">
        <article className="card">
          <h3>Social Badminton</h3>
          <p>Social badminton on three courts, twice a week, all year round.</p>
        </article>
        <article className="card">
          <h3>Beginner‑Friendly</h3>
          <p>Supportive environment with guidance for new and returning players.</p>
        </article>
        <article className="card">
          <h3>Junior Coaching</h3>
          <p>Junior programs led by certified coaches with clear development pathways.</p>
        </article>
        <article className="card">
          <h3>Pathways to Improve</h3>
          <p>Opportunities to grow at your own pace, on and off the court.</p>
        </article>
      </div>
    </div>
  );
}

export default ClubInfo;
